<template>
  <div class="collections-container">
    <div class="collections-list" v-if="!isDataLoading">
      <CollectionCard
        v-for="collection in currentCollections"
        :key="collection.collectionId"
        :collection="collection"
        :thumbs="collection.thumbs"
        @click="openCollection(collection)"
      />
    </div>
    <FavoritesSkeletonLoader v-else />
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';

import useCollections from '~/composables/useCollections';
import CollectionCard from '~/components/conversation/collections/CollectionCard';
import FavoritesSkeletonLoader from '~/components/conversation/favoritesPanel/FavoritesSkeletonLoader';
import useConversations from '~/composables/useConversations';

export default {
  props: {
    currentCollections: {
      type: Array,
      default: () => [],
    },
  },
  components: { CollectionCard, FavoritesSkeletonLoader },
  setup(props) {
    const { setThumbsCollectionsView } = useCollections();
    const { conversationScope, setConversationScope } = useConversations();
    const collection = ref({});

    const isDataLoading = ref(false);
    const isCreateCollectionPopupOpened = ref(false);

    const openCollection = (collection) => {
      const breadcrumb = [...conversationScope.value.breadcrumb, { title: ` ${collection.collectionName} ` }];
      setConversationScope({ isScoped: true, collection, breadcrumb });
    };

    onMounted(async () => {
      isDataLoading.value = true;
      await setThumbsCollectionsView(props.currentCollections, 5);
      isDataLoading.value = false;
    });

    return {
      collection,
      isCreateCollectionPopupOpened,
      isDataLoading,
      openCollection,
    };
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.collections-container {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  max-height: calc(100vh - 80px);

  // take into consideration the margins
  // height: 100%;
  //display: none;
  flex-direction: column;
  //background-color: $bb-neutral-7;
  //border-radius: $bb-spacing-8;
  //border: 1px solid #cecdcb;
  //box-shadow: 0 0 $bb-spacing-2 0 #0000001a;
  align-items: center;
  //min-width: 348px;
  //max-width: 348px;
  //padding: $bb-spacing-4 $bb-spacing-4 $bb-spacing-4 $bb-spacing-4;
  overflow: auto;
  width: 100%;

  .empty-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;

    :deep(span:first-of-type) {
      font-size: $bb-spacing-6;
      line-height: $bb-spacing-7;
    }
  }

  .collections-list {
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-4;
    width: 100%;
  }
}
</style>
